export const getPosition = (e, tooltipSize) => {
    let selectedTarget;
    if(e.target.tagName === 'I') {
        selectedTarget = e.target.parentNode.getBoundingClientRect();
    }else {
        selectedTarget = e.target.getBoundingClientRect();
    }

    const x = selectedTarget.x;
    const y = selectedTarget.y;
    const tooltipWidth = tooltipSize[0];
    const tooltipHeight = tooltipSize[1];
    const footerHeight = window.innerWidth > 1366? 48 : window.innerHeight > 992 ? 44 : 88;
    const headerHeight = 55;
    const iconWidth = selectedTarget.width;
    const iconHeight = selectedTarget.height;
    const margin = 36;
    const top = y - headerHeight;
    const right = document.getElementById('canvas').getBoundingClientRect().width - x;
    const bottom = window.innerHeight - y - headerHeight - footerHeight;
    const left = x;

    if((right - margin > tooltipWidth && bottom > tooltipHeight)) {
        return 'right'
    } 
    if((left - (margin-iconWidth) > tooltipWidth && bottom > tooltipHeight)) {
        return 'left';
    } 
    if(top - (margin-iconWidth) > tooltipHeight && right > tooltipWidth) {
        return 'topRight';
    } 
    if(top - (margin-iconWidth) > tooltipHeight && left > tooltipWidth - iconWidth) {
        return 'topLeft';
    } 
    if(bottom - (margin-iconHeight)> tooltipHeight && right > tooltipWidth) {
        return 'bottomRight';
    }
    if(bottom - (margin-iconHeight)> tooltipHeight && left > tooltipWidth - iconWidth) {
        return 'bottomLeft';
    }
    return 'right';
}